import "./CriticalDiagnosisListItem.css";

import { CaseDiagnosis } from "pwapi";

import { optimisticDiagnosisUpdate } from "shared/actions/specimenDetailActions";

import { DiagnosesObject } from "components/caseReport/CaseReport.types";
import { isDiagnosisCritical } from "components/caseReport/utils";
import { useAppDispatch } from "store/hooks";

const CriticalDiagnosisListItem = ({
  diagnosis,
}: {
  diagnosis: DiagnosesObject;
}) => {
  const dispatch = useAppDispatch();

  if (!diagnosis.diagnosis) return null;
  const diag = diagnosis.diagnosis;

  const isCritical =
    diag.critical_result_override ===
    CaseDiagnosis.critical_result_override.DEFAULT
      ? isDiagnosisCritical(diag)
      : diag.critical_result_override ===
        CaseDiagnosis.critical_result_override.CRITICAL;

  const onHandleClick = () => {
    diag.id &&
      dispatch(
        optimisticDiagnosisUpdate(
          {
            id: diag.id,
            critical_result_override: isCritical
              ? CaseDiagnosis.critical_result_override.NOT_CRITICAL
              : CaseDiagnosis.critical_result_override.CRITICAL,
          },
          diagnosis.specimen
        )
      );
  };

  return (
    <li className="CriticalDiagnosisListItem">
      <span>Specimen {diagnosis.specimen?.name}:</span>
      <label className="CriticalDiagnosisListItem__label">
        <input type="checkbox" checked={isCritical} onClick={onHandleClick} />
        Is Critical
      </label>
    </li>
  );
};

export default CriticalDiagnosisListItem;
